import GuideLayout from '@/components/Guides/GuideLayout';
export default function LearnLayout() { return <GuideLayout guideType="learn" />; }
